import { IncidentsActivityPanelNirvanaDataProvider } from '../dataProvider/IncidentsActivityPanelNirvanaDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_NIRVANA } from '../../../webcomponents.constants';

export class IncidentsActivityPanelDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_NIRVANA, IncidentsActivityPanelNirvanaDataProvider);
  }
}
